import { Component } from '@angular/core';
import { BaseCellRendererComponent } from '@predictiveindex/tapestry';
import { GuidUtilities } from '../core-utilities';
import { TranslationService } from '../translations';

@Component({
    selector: 'pi-resend-invite-cell-renderer',
    template: `
        @if (params.data.userId !== guidUtilities.getEmpty()) {
            <div>
                {{ params.value }}
            </div>
        } @else {
            @if (!isDisabled()) {
                <a (click)="onClick(); (false)">{{
                    this.TR.key('userManagement.resendInvitation')
                }}</a>
            }
            @if (isDisabled()) {
                <a class="disabled">{{
                    this.TR.key('userManagement.resendInvitation')
                }}</a>
            }
        }
    `,
    styles: [
        `
            a {
                cursor: pointer;
            }
            a.disabled {
                color: gray;
                cursor: not-allowed;
                text-decoration: underline;
            }
        `
    ],
    standalone: false
})
export class ResendInviteCellRendererComponent extends BaseCellRendererComponent {
    disabled = false;
    constructor(
        public TR: TranslationService,
        public guidUtilities: GuidUtilities
    ) {
        super();
    }

    // feeling a bit uneasy about this. params is of <any> type should be typed.
    // same with action -> it should have at least Promise<any> type.
    onClick(): void {
        this.disable();
        this.params.action(this.params).finally(() => {
            setTimeout(() => this.enable(), 2000);
        });
    }

    enable(): void {
        if (this.params.enableLink) {
            this.disabled = false;
        }
    }

    disable(): void {
        if (this.params.enableLink) {
            this.disabled = true;
        }
    }

    isDisabled(): boolean {
        return !this.params.enableLink || this.disabled;
    }
}
